export const notifyApp = function (data = {}) {
  if (window && window.ReactNativeWebView) {
    window.ReactNativeWebView?.postMessage(JSON.stringify(data));
  }
};
